module.exports = __webpack_public_path__ + "img/header-weddingRingsModern.667f7df.webp";